import * as React from 'react';
import { SharedUiPropertyActivitiesCrossSellWrapper } from 'components/infosite/shared-ui/offers/shared-ui-property-activities-cross-sell';
export const PropertyActivitiesCrossSell = () => React.createElement(SharedUiPropertyActivitiesCrossSellWrapper, null);